import { render, staticRenderFns } from "./checkSalaryList.vue?vue&type=template&id=6f70908c&scoped=true"
import script from "./checkSalaryList.vue?vue&type=script&lang=js"
export * from "./checkSalaryList.vue?vue&type=script&lang=js"
import style0 from "./checkSalaryList.vue?vue&type=style&index=0&id=6f70908c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6f70908c",
  null
  
)

export default component.exports